import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_LEGAL,
  DELETE_LEGAL,
  UPDATE_LEGAL,
  ADD_NEW_LEGAL,
} from "./actionType";

import {
  getLegalSuccess,
  getLegalFail,
  deleteLegalSuccess,
  deleteLegalFail,
  updateLegalSuccess,
  updateLegalFail,
  addLegalSuccess,
  addLegalFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveLegalApi,
  getLegalApi,
  updateLegalApi,
  deleteLegalApi,
  addNewLegalApi
} from "../../helpers/backend_helper";

function* getLegal({ payload: legal }) {
  try {
    const response = yield call(getLegalApi, legal);
    yield put(getLegalSuccess(GET_LEGAL, response.data));
  } catch (error) {
    yield put(getLegalFail(GET_LEGAL, error));
  }
}

function* onUpdateLegal({ payload: legal }) {
  try {
    if (legal.setApprove) {
      const response = yield call(approveLegalApi, legal);
      yield put(updateLegalSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateLegalApi, legal);
      yield put(updateLegalSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateLegalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteLegal({ payload: legal }) {
  try {
    const response = yield call(deleteLegalApi, legal);
    yield put(deleteLegalSuccess({ legal, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteLegalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewLegal({ payload: legal }) {
  try {
    const response = yield call(addNewLegalApi, legal);
    yield put(addLegalSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addLegalFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetLegal() {
  yield takeEvery(GET_LEGAL, getLegal);
}

export function* watchUpdateLegal() {
  yield takeEvery(UPDATE_LEGAL, onUpdateLegal);
}

export function* watchDeleteLegal() {
  yield takeEvery(DELETE_LEGAL, onDeleteLegal);
}

export function* watchAddNewLegal() {
  yield takeEvery(ADD_NEW_LEGAL, onAddNewLegal);
}

function* legalSaga() {
  yield all([
    fork(watchGetLegal),
    fork(watchDeleteLegal),
    fork(watchUpdateLegal),
    fork(watchAddNewLegal)
  ]);
}

export default legalSaga;
